import { FC, ReactNode } from 'react'
import Foldable from '../Foldable'
import { SectionBodyFoldableContent } from './styles'

type Props = {
  isOpened?: boolean
  isDragging?: boolean
  children: ReactNode
  isStepByStepFlow?: boolean
}

export const SectionBodyFoldableContainer: FC<Props> = props => {
  const { isOpened, children, isDragging, isStepByStepFlow } = props

  if (isDragging) {
    return null
  }

  return (
    <Foldable isOpen={isOpened}>
      <SectionBodyFoldableContent isStepByStepFlow={isStepByStepFlow}>
        {children}
      </SectionBodyFoldableContent>
    </Foldable>
  )
}
